module.exports = __webpack_public_path__ + "img/chevron_white_right_32px.92d85012.png";